"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _tab = _interopRequireDefault(require("../../../../elements/tab"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../../elements/other/headline-lockup/index.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _planBoxSubscriptionItem = _interopRequireDefault(require("../../plan-box-section-subscription/plan-box-subscription-item"));
var _scrollIndicator = _interopRequireDefault(require("../../plan-box-section-subscription/scroll-indicator"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const sectionStyles = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
};
const AboveCards = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AboveCards",
  class: "pl-a1mkuf2j"
});
const TabContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabContainer",
  class: "pl-tmep3rp"
});
const TabBackground = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabBackground",
  class: "pl-to5hrze"
});
const LineupName = /*#__PURE__*/(0, _react2.styled)("h3")({
  name: "LineupName",
  class: "pl-l1ccw23b"
});
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-c1p8v4b",
  vars: {
    "c1p8v4b-0": [({
      col
    }) => col],
    "c1p8v4b-1": [({
      hasFlag
    }) => hasFlag ? 'var(--fixed-space-500)' : '0'],
    "c1p8v4b-3": [({
      col
    }) => {
      if (col === 4) {
        return `100vw`;
      } else if (col === 3) {
        return `80rem`;
      } else if (col === 2) {
        return `60rem`;
      }
      return `35rem`;
    }]
  }
});

/**
 * TabbedPlanBoxSection Component.
 * @module TabbedPlanBoxSection
 *
 * @deprecated This component is deprecated. Please use SimplePlanBoxSection instead.
 * @param {Object} props React props
 * @param {String} props.id An unique identifier
 * @param {String} props._name Tracking name
 * @param {Array} props.tabs An array of Tabs
 * @param {String} props.verticalMargin Vertical Layout Spacing Values
 * @returns {React.ReactElement} TabbedPlanBoxSection Component
 * @public
 */

function TabbedPlanBoxSection({
  _name,
  tabs,
  verticalMargin,
  ...headlineProps
}) {
  const [activeTab, setActiveTab] = (0, _react.useState)(tabs && tabs[0]);
  const switchTab = tabId => {
    const tab = tabs.find(t => t.id === tabId);
    setActiveTab(tab);
  };
  const {
    heading,
    eyebrow
  } = headlineProps;
  const {
    lineupName,
    items
  } = activeTab;
  const hasImages = !!items?.find(i => i.image);
  const target = /*#__PURE__*/_react.default.createRef();
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    style: sectionStyles,
    _name: _name,
    dataCy: "tabbed-plan-box-section",
    verticalMargin: verticalMargin,
    padding: "none"
  }, /*#__PURE__*/_react.default.createElement(AboveCards, null, (heading || eyebrow) && /*#__PURE__*/_react.default.createElement(_index.default, headlineProps), /*#__PURE__*/_react.default.createElement(TabContainer, null, /*#__PURE__*/_react.default.createElement(TabBackground, null, tabs && tabs.map(tab => {
    const {
      name,
      id
    } = tab;
    return /*#__PURE__*/_react.default.createElement(_tab.default, (0, _extends2.default)({}, tab, {
      label: name,
      isActive: activeTab.id === id,
      key: id,
      switchTab: switchTab
    }));
  }))), lineupName && /*#__PURE__*/_react.default.createElement(LineupName, null, lineupName)), items && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CardContainer, {
    "data-cy": "card-container",
    hasFlag: items.reduce((anyFlags, {
      flag
    }) => anyFlags || flag, false),
    col: items.length,
    ref: target
  }, items.slice(0, 4)?.map((item, idx) => {
    const {
      price,
      image
    } = item;
    return /*#__PURE__*/_react.default.createElement(_planBoxSubscriptionItem.default, (0, _extends2.default)({
      col: idx + 1,
      key: idx,
      showImageWrapper: hasImages,
      image: image,
      price: price
    }, item));
  })), items?.length > 1 && /*#__PURE__*/_react.default.createElement(_scrollIndicator.default, {
    elementArr: items.length,
    element: target
  })));
}
var _default = exports.default = TabbedPlanBoxSection;
TabbedPlanBoxSection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape(_tab.default.propTypes)),
  ..._patternLibraryUtils.marginProps
};